import React from 'react';
import { LineTabs as LineTabsNew } from './LineTabs';
import { convertOldLineTabsProps } from './converter.old';
import type { OldLineTabsComponentProps, OldLineTabsProps } from './converter.old';

export type LineTabsProps = OldLineTabsProps;
export type LineTabsComponentProps = OldLineTabsComponentProps;

export const LineTabs: React.FC<LineTabsComponentProps> = (props) => (
  <LineTabsNew {...convertOldLineTabsProps(props)} />
);
